/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

export function ZetaElement(props) {
  const { em } = props;
  const elementProperty = {
    id: em.id,
    name: em.name,
    className: em.class
  }

  let elementChild = '';

  if (em.content) elementChild = em.content;
  if (props.data && em && em.field) {
    elementChild = (props.data && em && em.field && props.data[em.field]) || '';
  }

  return React.createElement(em.tagName, elementProperty, elementChild);
}

ZetaElement.propTypes = {
  app : PropTypes.any, 
  em : PropTypes.any, 
  data : PropTypes.any
}